import { useTranslation } from 'react-i18next';
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';
import GoodsSupplierConnectionFields from 'components/GoodsSupplierConnectionFields/GoodsSupplierConnectionFields';
import ManufactureConnectionFields from 'components/ManufactureConnectionFields/ManufactureConnectionFields';
import UnitLinkChips from 'components/UnitLinkField/components/UnitLinkChips';
import { SOURCING_CONNECTIONS } from 'constants/formFields';
import { SOURCING_KINDS } from 'utils/sourcingConnections';

import type { FieldPath } from 'react-hook-form';
import type { TCreateProductSchema } from 'utils/validators';
import type ISourcingConnectionItem from '../interfaces/ISourcingConnectionItem';

import styles from '../sass/SourcingConnections.module.scss';

function SourcingConnectionItem({
  control, index, kind, enumData, from, onRemove,
}: Readonly<ISourcingConnectionItem>) {
  const { t } = useTranslation();

  // Field names are indexed into the sourcing array, so the same controls serve every row.
  const fieldName = (field: string) => (
    `${SOURCING_CONNECTIONS}.${index}.${field}` as FieldPath<TCreateProductSchema>
  );

  return (
    <div className={styles.item}>
      <div className={styles.itemHeader}>
        <UnitLinkChips items={[from]} hideRemove />
        <button
          type="button"
          className={styles.deleteButton}
          onClick={onRemove}
          aria-label={`${t('common.delete')} ${from.name}`}
        >
          <TrashIcon />
        </button>
      </div>

      {kind === SOURCING_KINDS.MANUFACTURE ? (
        <ManufactureConnectionFields control={control} fieldName={fieldName} />
      ) : (
        <GoodsSupplierConnectionFields
          control={control}
          enumData={enumData}
          fieldName={fieldName}
        />
      )}
    </div>
  );
}

export default SourcingConnectionItem;
